import React, { useCallback } from "react";
import { AHIcon, AHInput, Box, useLayoutContext, useTheme } from "arkh";
import { graphql, useFragment, useMutation } from "react-relay";
import { TodoEditNewMainFooterResponseText_todo$key } from "./__generated__/TodoEditNewMainFooterResponseText_todo.graphql";

import { View } from "react-native";
import { TodoEditNewMainFooterResponseTextrMutation } from "./__generated__/TodoEditNewMainFooterResponseTextrMutation.graphql";
import { useIntl } from "react-intl";
import { useDebouncedMutation } from "@/src/common/Utils/useDebouncedMutation";

export function TodoEditNewMainFooterResponseText(props: {
  todo: TodoEditNewMainFooterResponseText_todo$key;
  autoFocus?: boolean;
}) {
  const todo = useFragment(
    graphql`
      fragment TodoEditNewMainFooterResponseText_todo on Todo {
        canWrite
        id
        status

        isResponseCompleted

        response {
          ... on TodoResponseText {
            text
          }
        }
      }
    `,
    props.todo
  );

  const [mutation] = useMutation<TodoEditNewMainFooterResponseTextrMutation>(
    graphql`
      mutation TodoEditNewMainFooterResponseTextrMutation(
        $todoId: ID!
        $input: UpdateTodoTextResponseInput!
      ) {
        todo(todoId: $todoId) {
          updateTextResponse(input: $input) {
            isResponseCompleted
            canChangeStatus
            parent {
              canChangeStatus
            }
            response {
              ... on TodoResponseText {
                text
              }
            }
          }
        }
      }
    `
  );

  const setValue = useCallback(
    (text: string | undefined) => {
      mutation({
        variables: {
          todoId: todo.id,
          input: {
            text,
          },
        },
      });
    },
    [mutation, todo.id]
  );
  const remoteValue = todo.response?.text ?? undefined;

  const [local, setR] = useDebouncedMutation(remoteValue, setValue);
  const layout = useLayoutContext();
  const intl = useIntl();
  const editable = todo.status === "PENDING" && todo.canWrite;
  const theme = useTheme();
  return (
    <View>
      <AHInput
        preventWebClickPropagation
        autoFocus={props.autoFocus && !todo.isResponseCompleted}
        textType="subtitle"
        value={local}
        editable={editable}
        onChangeText={setR}
        placeholder={intl.formatMessage({
          defaultMessage: "Enter text...",
          description: "Todo text response required to submit message",
        })}
        cornerRadius="medium"
        color="surface-backgroundControl"
        borderColor={"border-primary"}
        style={{
          flexDirection: "row",
          alignItems: "center",
          backgroundColor: theme.background,
          borderWidth: 1,
          overflow: "hidden",
          paddingVertical: layout.space.medium,
          paddingLeft: layout.space.medium + layout.circle.smallMedium,
        }}
      />
      <Box
        style={{
          position: "absolute",
          top: 0,
          bottom: 0,
          left: layout.space.medium,
          justifyContent: "center",
        }}
      >
        <AHIcon
          type="text-input"
          color="primary"
          forceSize={layout.circle.smallMedium}
        />
      </Box>
    </View>
  );
}
